const { makeStyles } = require("@material-ui/core");

export const useStyles = makeStyles((theme) => ({
  header: {
    color: theme.palette.primary.main,
  },
  main: {
    ...theme.mainContent,
    width: "100%",
  },
  mainMD: {
    ...theme.mainContentMD,
  },
  fixed: {
    position: "sticky",
    top: 0,
    width: "100%",
    zIndex: 100,
  },
  tableContainer: {
    width: "100%",
  },
  imgContainer: {
    display: "flex",
    flexWrap: "wrap",
    margin: "-10px",
  },
  imgItem: {
    padding: "10px",
    width: "33.3%",
  },
  flexList: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
  },
  flexListItem: {
    width: "100%",
  },
  flexListHeader: {
    ...theme.typography.h1,
    fontSize: "16px",
  },
  flexListInfo: {
    padding: 0,
    margin: 0,
    color: `#0028fa`,
    paddingLeft: 4,
    fontSize: "12px",
    lineHeight: "18px",
  },
  flexHeader: {
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
  },
  list: {
    display: "flex",
    flexWrap: "wrap",
    margin: "-10px",
  },
  listItem: {
    display: "flex",
    width: "33.3%",
    padding: "10px",
    alignItems: "center",
  },
  listItemMD: {
    display: "flex",
    width: "50%",
    padding: "10px",
    alignItems: "center",
  },
  formList: {
    display: "flex",
    justifyContent: "space-between",
  },
  listItemMD: {
    width: "33.3%",
  },
  flexForm: {
    marginBottom: "8px",
  },
  shortListCard: {
    height: "200px",
    background: "red",
  },
  shortListFooter: {
    padding: "0px 10px 10px 10px",
    margin: "0 auto",
  },
  input: {
    display: "none",
  },
  image: {
    objectFit: "contain",
  },
  rowImage: {
    width: "55px",
    minWidth: "55px",
    height: "45px",
    borderRadius: 4,
    overflow: "hidden",
  },
  userHeader: {
    position: "sticky",
    top: 0,
    width: "100%",
    zIndex: 20,
    ...theme.borderBottom,
    padding: "0px 20px",
    background: "#fff",
  },
  content: {
    ...theme.mainContentMD,
  },
  tableActionBox: {
    display: "flex",
    justifyContent: "flex-end",
    marginBottom: "15px",
  },
}));
